

import VueRouter from 'vue-router';

export default {
  data() {
    return {
      router: null,
      selectedTabSlug: '',
    };
  },

  props: {
    defaultTabIndex: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    hasContent: function(){
      return this.$slots.research || this.$slots.bio || this.$slots.publications;
    },
    params: function(){
      var params = {};

      if(this.selectedTabSlug.length) {
        params.tab = this.selectedTabSlug;
      }

      return params;
    },
  },

  watch: {
    selectedTabSlug: function (newValue, oldValue) {
      this.updateRoutes();
    },
  },

  methods: {
    makeUrlForTab: function(slug) {
      return window.location.pathname+'?tab='+slug;
    },
    updateRoutes: function() {
      if(this.router != null) {
        this.router.push({ path: window.location.pathname, query: this.params}).catch(err => {  }); // eslint-disable-line
      }
    },
    didSelectTab: function (tabSlug) {
      this.selectedTabSlug = tabSlug;
    },
    selectFirstTab: function () {
      if(!this.hasContent) return;

      if(this.$slots.research) {
        this.selectedTabSlug = 'research';
        return;
      }

      if(this.$slots.bio) {
        this.selectedTabSlug = 'bio';
        return;
      }

      if(this.$slots.publications) {
        this.selectedTabSlug = 'publications';
        return;
      }

    },
  },

  components: {},

  created() {},

  destroyed() {},

  mounted() {
    var self = this,
    urlParams = new URLSearchParams(window.location.search);

    if(self.hasContent && urlParams.get('tab')) {
      self.selectedTabSlug = urlParams.get('tab');
    } else {
      self.selectFirstTab()
    }

    self.router  = new VueRouter({mode: 'history'});

  },
};



// WEBPACK FOOTER //
// ./scripts/vue/PersonDetail.vue